import type { Property } from '~/core/entities/property';

import { useEvents } from '~/composables/events/useEvents';
import { useLastSrpUrl } from '~/composables/useLastSrpUrl';
import { MixpanelProps } from '~/core/service/mixpanel';
import { PropertyFiltersPresenter } from '~/presenters/PropertyFiltersPresenter';

interface UsePropertyHeroNavigationOptions {
	property: Ref<Property | null>;
}

export function usePropertyHeroNavigation({
	property
}: UsePropertyHeroNavigationOptions) {
	const router = useRouter();
	const { trackReturnPropertyDetails, trackSearchBarClicked } = useEvents();
	const { lastSrpUrl, syncLastSrpUrl } = useLastSrpUrl();

	const fallbackBackUrl = computed(() => {
		const filters = PropertyFiltersPresenter.createLocationFilters({
			regions: [property.value?.region ?? ''],
			states: [property.value?.state ?? ''],
			cities: [property.value?.city ?? '']
		});

		return PropertyFiltersPresenter.getPathFromFilters(filters);
	});

	const backButtonHoverText = computed(() =>
		lastSrpUrl.value ? 'Voltar para busca' : property.value?.region
	);

	function handleBackButtonClick() {
		syncLastSrpUrl();
		const destinationUrl = lastSrpUrl.value ?? fallbackBackUrl.value;

		trackReturnPropertyDetails({
			[MixpanelProps.CURRENT_PAGE]: 'Property Details',
			[MixpanelProps.COMMERCIAL_ID]: property.value?.commercialId ?? '',
			[MixpanelProps.NEIGHBORHOODS_NAME]: property.value?.region ?? '',
			[MixpanelProps.DESTINATION_URL]: destinationUrl
		});

		router.push(destinationUrl);
	}

	function handleSearchBarClick() {
		trackSearchBarClicked({
			[MixpanelProps.CURRENT_PAGE]: 'Property Details',
			[MixpanelProps.COMMERCIAL_ID]: property.value?.commercialId ?? ''
		});
	}

	return {
		backButtonHoverText,
		handleBackButtonClick,
		handleSearchBarClick
	};
}
